import axios, { type CreateAxiosDefaults } from 'axios';

export const defaults: CreateAxiosDefaults = {
  timeout: 30000
};

export default axios.create(defaults);
